
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import Foot from './foot'
export default {
name: 'drawer',
components: {
Foot,
XButton,
Group,
Confirm,
Badge
},
data () {
return {
$vue: '',
username: '', // 登录名
role: '', // 角色名称
PICTURE_URL: '', // 医生头像
isAuth: '',
unReadnum: '',
showLoginout: false,

contentCanMove: true,
mrPictureUrl: '../../../static/img/touxiang.png'
}
},
methods: {

toggleDrawer () {
this.$refs.drawer.toggle()
},

async queryUnreadNum () {
let suc = await this.$http.post(this.$vue.getData('QUERY_UNREAD_NUM'))
if (suc.data.result === '1') {
let num = suc.data.data.unReadnum
if (num > 99) {
num = '99+'
}
this.unReadnum = num
}
},

goWxBinding () {

this.$http.post(this.$vue.getData('PERSONINFO_URL')).then(suc => {

})
},
async goMessageCenter () {
this.$router.push({path: '/messagecenter'})
},
goCellection () {
this.$router.push({path: '/collection'})
},
/**
* 获取个人信息
* 收藏，预约病例，诊断数量，暂未获取
*/
goMyselfInfo () {
this.$router.push({path: '/personinfo/personInfoDetail'})
},
exit () {
this.toggleDrawer()
this.showLoginout = true
},
/**
* @author      dongkuoji
* @description 退出登录
* @date        2018/4/20 15:24
*/
loginout () {

this.$http.post(this.$vue.getData('LOGIN_OUT_URL'))





}
},
beforeMount () {
this.$vue = this
this.queryUnreadNum()
},
mounted () {
this.$http.post(this.$vue.getData('PERSONINFO_URL')).then(suc => {
let data = suc.data.data
this.PICTURE_URL = data.PICTURE_URL
this.username = data.USERNAME
this.isAuth = data.STATUS
this.role = data.role_name
})
},
beforeRouteEnter (to, from, next) {

if (localStorage.getItem('PHONE')) {
next({name: 'SubmitInformation'})
}

if (localStorage.getItem('JWT_TOKEN')) {
next()
} else {
next({name: 'Login'})
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/index.vue